import * as React from 'react';
import { styles } from './styles';
import { ApolloError } from 'apollo-client';
import { BaseButton } from '@routes/event/create/components/BaseButton';
import CopyToClipboard from 'react-copy-to-clipboard';
import InlineSVG from 'svg-inline-react';
import { ErrorInfo } from '../..';

const checkSVG = require('../../assets/icon-check.svg');
const copySVG = require('../../assets/icon-copy.svg');

interface Props {
  error: ApolloError | ApolloError[];
}

type State = Readonly<{
  copied: boolean;
  show: boolean;
}>;

export class ErrorMessage extends React.PureComponent<Props, State> {
  readonly state = {
    copied: false,
    show: false
  };

  handleOnShowClick = () => this.setState({ show: true });

  renderShowButton = () => {
    return (
      <BaseButton className={styles.exploreIssueButton} onClick={this.handleOnShowClick}>
        <span>Still having trouble?</span>
      </BaseButton>
    );
  };

  renderMessage = () => {
    const { error } = this.props;
    let errorInfo = { stack: '', message: '' };
    if (Array.isArray(error)) {
      errorInfo = error.reduce((accumulator: ErrorInfo, currentValue: ApolloError) => {
        accumulator.stack += `${currentValue.stack}\n`;
        accumulator.message += `${currentValue.message}\n`;
        return accumulator;
      }, errorInfo);
    } else {
      errorInfo.message = error.message ? error.message : 'Unknown Error';
      errorInfo.stack = error.stack ? error.stack : 'No Error Stack';
    }
    const { copied } = this.state;

    return (
      <>
        <span className={styles.message}>{errorInfo.message}</span>
        <CopyToClipboard
          text={JSON.stringify(errorInfo.stack)}
          onCopy={() => {
            this.setState({ copied: true });
          }}
        >
          <span className={styles.svgContainer}>
            <InlineSVG className={styles.svg} src={copied ? checkSVG : copySVG} />
            <span>{copied ? 'Copied' : 'Copy'}</span>
          </span>
        </CopyToClipboard>
      </>
    );
  };

  render(): React.ReactNode {
    return <div className={styles.container}>{this.state.show ? this.renderMessage() : this.renderShowButton()}</div>;
  }
}
